import axios from 'axios'
import Vue from 'vue'
import router from '../router'
import config from '../api/config'
// import _ from 'lodash'

let REST_URL = config.baseurl
if (navigator.userAgent.includes('selenium')) {
  REST_URL = 'http://backend:8000'
}

const initialState = {
//  myProjectList: [], // my project
  myProjectListResponses: {count: 0, pages: []},
  userInfo: {},
  institutions: [],
  student_projectsInMyClassrooms: {},
  teacher_ClassSharedProjects: {},
  projectsPerQuery: 30
}

const getters = {
  isUserTeacher: state => {
    if (state.userInfo && state.userInfo.owns_classrooms && state.userInfo.owns_classrooms.length > 0) return true
    else return false
  },
  myProjectList: state => {
    return Vue._.flatten(state.myProjectListResponses.pages)
  }

}

const actions = {
  fetchUserInfo: (context, force) => {
    if (force === undefined) force = true
    if (!Vue._.isEmpty(context.state.userInfo) && force === false) return Promise.resolve()
    // if( context.rootState.auth.userid == null )
    return axios.get(REST_URL + '/users/' + context.rootState.auth.userid + '/').then((response) => {
      // console.log('fetchUserInfo', 'OK', response.data)
      context.commit('setUserInfo', response.data)
    }).catch((error) => {
      // console.log('fetchUserInfo', 'FAIL', error)
      if (error.response.status === 404 || error.response.status === 403 || error.response.status === 401) {
        // commit('wrongSession')
        context.commit('auth/LOGOUT', null, { root: true })
        context.commit('auth/REMOVE_TOKEN', null, { root: true })
        context.commit('clean')
        router.replace({name: 'login2', params: { 'isLogin': true, 'toastMsg': 'Lo sentimos tu sesión ha caducado. Necesitas volver entrar de nuevo con tu usuario y contraseña' }})
      }
    })
  },
  fetchUserIdInfo: (context, id) => {
    return axios.get(REST_URL + '/users/' + id + '/').then((response) => {
      console.log('fetchUserIdInfo', 'OK', response.data)
      context.commit('setUserInfo', response.data)
    }).catch((error) => {
      console.log('fetchUserInfo', 'FAIL', error)
    })
  },
  fetchMyProjects: (context, pagenumber) => {
    if (pagenumber === undefined) pagenumber = 1
    let query = {
      params: {
        owner: context.rootState.auth.userid,
        limit: 1000,
        page: pagenumber
      }
    }
    let rep = axios.get(REST_URL + '/project/', query).then((response) => {
      context.commit('setMyProjects', {projectList: response.data, pagenumber: pagenumber})
    }).catch((error) => {
      console.log('fetchProjectList', 'FAIL', error)
    })
    return rep
  },

  fetchProjectsForUserId: (context, id) => {
    console.log('fetchProjectsForUserId')

    let query = {
      params: {
        owner: id,
        page: 1,
        limit: 1000
      }
    }
    let rep = axios.get(REST_URL + '/project/', query).then((response) => {
      console.log(response.data)
      return response.data
    }).catch((error) => {
      console.log('fetchProjectList', 'FAIL', error)
    })
    return rep
  },

  teacher_fetchProjectsSharedWithMe: (context, classroomId) => {
    // http://127.0.0.1:8000/project/?classroom=5&is_shared_with_teacher=false
    let query = {
      params: {
        'classroom': classroomId
        // 'is_shared_with_teacher': true
      }
    }
    let rep = axios.get(REST_URL + '/project/', query).then((response) => {
      // console.log('fetchProjectList', 'OK', response.data)
      context.commit('teacher_ClassSharedProjects', {'classid': classroomId, 'data': response.data.results})
    }).catch((error) => {
      console.log('teacher_fetchProjectsSharedWithMe', 'FAIL', error)
    })
    return rep
  },

  /* for a classid get all the project in that classid projects **/
  /* fetchMyClassprojects: (context, classid) => {
    let query = {
      params: {
        classroom: classid
      }
    }
    return axios.get(REST_URL + '/project/', query).then((response) => {
      // console.log('fetchProjectList', 'OK', response.data)
      context.commit('setProjectsInClassroom', {'classid': classid, 'data': response.data.results})
    }).catch((error) => {
      console.log('fetchMyClassprojects', 'FAIL', error)
    })
  }, */

  student_fetchProjectsSharedInMyClassroom: (context, {classid, teacherid}) => {
    let query = {
      params: {
        classroom: classid,
        owner: teacherid
      }
    }
    return axios.get(REST_URL + '/project/', query).then((response) => {
      // console.log('fetchProjectList', 'OK', response.data)
      context.commit('student_setProjectsInMyClassroom', {'classid': classid, 'data': response.data.results})
    }).catch((error) => {
      console.log('student_fetchProjectsSharedInMyClassroom', 'FAIL', error)
    })
  },

  fetchInstitutions: (context) => {
    const request = axios.get(REST_URL + '/institution/')
    request.then(response => {
      context.commit('setInstitutions', response.data)
    }).catch((error) => {
      console.log('setInstitutions', 'FAIL', error)
    })
    return request
  },

  fetchUserFiles: (context) => {
    const request = axios.get(REST_URL + '/uploadedfiles/')
    return request
  },
  deleteUserFile: (context, fileid) => {
    const request = axios.delete(REST_URL + '/uploadedfiles/' + fileid)
    return request
  },

  saveChangesProfile: (context, fields) => {
    return axios.patch(REST_URL + '/users/' + context.rootState.auth.userid + '/', fields)
  },

  uploadNewPhoto: (context, file) => {
    const data = new FormData()
    data.append('picture', file, context.rootState.auth.userid + '.png')
    // now upload
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return Vue.axios.patch(REST_URL + '/users/' + context.rootState.auth.userid + '/', data, config).then(response => {
      console.log(response.data)
    })
  },

  addClassroom: (context, {name, description, owner, institution}) => {
    const request = axios.post(REST_URL + '/addclassroom/', {'name': name, 'description': description, 'owner': owner, 'institution': institution})
    return request.then(response => {
      return response
    }).catch((error) => {
      console.log('addClassroom', 'FAIL', error)
      return Promise.reject(error)
    })
  },

  addInstitution: (context, {name, provincia, city}) => {
    const request = axios.post(REST_URL + '/institution/', {'name': name, 'provincia': provincia, 'city': city})
    return request.then(response => {
      return response
    }).catch((error) => {
      console.log('addInstitution', 'FAIL', error)
      return Promise.reject(error)
    })
  },

  addMeToClassroom: (context, classid) => {
    const request = axios.patch(REST_URL + '/classroom/' + classid + '/')
    return request.then(response => {
      return response
    }).catch((error) => {
      return Promise.reject(error)
    })
  },

  deleteMyUser: (context) => {
    const request = axios.delete(REST_URL + '/users/' + context.rootState.auth.userid + '/')
    return request.then(response => {
      return response
    }).catch((error) => {
      return Promise.reject(error)
    })
  },
  setMyTerms: (context, acceptsContact) => {
    const request = axios.patch(REST_URL + '/settermsconditions/', {'acceptsContact': acceptsContact})
    return request.then(response => {
      return response
    }).catch((error) => {
      return Promise.reject(error)
    })
  }
}

const mutations = {
  setUserInfo: (state, userinfo) => {
    state.userInfo = userinfo
  },
  setMyProjects: (state, data) => {
    state.myProjectListResponses.count = data.projectList.count
    Vue.set(state.myProjectListResponses.pages, data.pagenumber - 1, data.projectList.results)
  /*  if (state.myProjectList.results) { // concatenamos si existen
      state.myProjectList.results = state.myProjectList.results.concat(projectList.results)
    } else { // sino creamos
      state.myProjectList = projectList
    } */
  },
  setInstitutions: (state, institutions) => {
    state.institutions = institutions
  },
  student_setProjectsInMyClassroom: (state, {classid, data}) => {
    Vue.set(state.student_projectsInMyClassrooms, classid, data)
  },
  teacher_ClassSharedProjects: (state, {classid, data}) => {
    Vue.set(state.teacher_ClassSharedProjects, classid, data)
  },
  clean: (state) => {
    // Vue.set(state, 'myProjectList', [])
    Vue.set(state, 'myProjectListResponses', {count: 0, pages: []})
    Vue.set(state, 'userInfo', {})
    Vue.set(state, 'institutions', [])
    Vue.set(state, 'projectsInMyClassroomsAsStudent', {})
  }

}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user.js